import RoleCategory from "models/RoleCategory";
import serviceFetch from "services/helpers";
import { AuthStore } from "store/Auth";

const path = "proxy/role-categories";

export const fetchRoleCategories = async (
  auth: AuthStore
): Promise<Array<RoleCategory>> => serviceFetch(auth, path, null, "get");
